module.exports = __webpack_public_path__ + "img/banner.dcfb0259.webp";